import React, {ComponentProps, useState} from "react";
import * as api from "../../apis/rebate";
import useAntTable from "../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import Divider from "../../components/Divider";
import DatePicker from "../../components/DatePicker";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import {Button, Form, Space} from "antd";
import {Link, useHistory} from "react-router-dom";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import DictSelect from "../../components/DictSelect";
import {PlatformType, RebateBusinessScopeMapping, RebateStatusMapping} from "../../utils/constants";
import dayjs from "dayjs";
import withAuth from "../../utils/withAuth";
import UploadModal from "../../components/UploadModal";
import {useRequest} from "ahooks";

const AddButton = withAuth('add', Button);
const ImportButton = withAuth('add', Button);

function Rebate(props: ComponentProps<any>) {
    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform ?? PlatformType.Dealer;
    const history = useHistory();
    const dict = useSelector<RootState, RootState['dict']>(state => state.dict);
    const {tableProps, form, search, refresh} = useAntTable(api.getRebates, {});

    const [uploadModalVisible, setUploadModalVisible] = useState(false)

    const {run: doImport, loading: doImportLoading} = useRequest(api.importRebateOrders, {
        manual: true,
        onSuccess: () => {
            setUploadModalVisible(false)
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            dataIndex: 'code',
            key: 'code',
            title: '返利单号'
        },
        {
            dataIndex: 'dealerName',
            key: 'dealerName',
            title: '客户名称'
        },
        {
            dataIndex: 'rebateType',
            key: 'rebateType',
            title: '返利类型',
            render(v) {
                return dict?.['RebateType']?.[v];
            }
        },
        {
            dataIndex: 'businessScope',
            key: 'businessScope',
            title: '业务范围',
            render(v) {
                return RebateBusinessScopeMapping[v];
            }
        },
        {
            dataIndex: 'rebateAmount',
            key: 'rebateAmount',
            title: '返利额度'
        },
        {
            dataIndex: 'remainingAmount',
            key: 'remainingAmount',
            title: '剩余额度'
        },
        {
            dataIndex: 'startDate',
            key: 'startDate',
            title: '开始日期',
            render(v) {
                return v && dayjs(v).format('ll')
            }
        },
        {
            dataIndex: 'endDate',
            key: 'endDate',
            title: '结束日期',
            render(v) {
                return v && dayjs(v).format('ll')
            }
        },
        {
            dataIndex: 'status',
            key: 'status',
            title: '状态',
            render(v) {
                return RebateStatusMapping[v]
            }
        },
        {
            dataIndex: 'operation',
            key: 'operation',
            title: '操作',
            render(v: any, r: any) {
                return <Divider>
                    <Link to={`/rebate/rebate/detail/${r.id}`}>详情</Link>
                </Divider>
            }
        }
    ];
    const adminSearchColumns: StandardColumnsType = [
        {
            dataIndex: 'dealerName',
            title: '客户名称',
            search: true
        },
    ];
    const commonSearchColumns: StandardColumnsType = [
        {
            dataIndex: 'rebateOrderCode',
            title: '返利单号',
            search: true
        },
        {
            dataIndex: 'rebateType',
            title: '返利类型',
            search: {
                valueRender: <DictSelect dict={'RebateType'} nullLabel={'请选择'}/>
            }
        },
        {
            dataIndex: 'businessScope',
            title: '业务范围',
            search: {
                valueType: 'select',
                valueEnum: [
                    {value: 0, text: '全部'},
                    {value: 1, text: '产品线'},
                    {value: 2, text: '商品'},
                    {value: 3, text: '合同'}
                ],
                valueInitial: 0
            }
        },
        {
            dataIndex: 'status',
            title: '状态',
            search: {
                valueType: 'select',
                valueEnum: [
                    {value: 0, text: '未审核'},
                    {value: 1, text: '已审核'},
                    {value: 2, text: '已生效'},
                    {value: 3, text: '已关闭'},
                ]
            }
        },
        {
            dataIndex: 'dateRange',
            title: '生效日期',
            search: {
                valueRender: (<>
                    <Form.Item name={'startDate'} noStyle/>
                    <Form.Item name={'endDate'} noStyle/>
                    <DatePicker.RangePicker onChange={(values) => {
                        const [startDate, endDate] = values as any;
                        debugger
                        form.setFieldValue('startDate', startDate ? startDate.format('YYYY-MM-DD') : null);
                        form.setFieldValue('endDate', endDate ? endDate.format('YYYY-MM-DD') : null);
                    }}/>
                </>)
            }
        }
    ];
    const searchColumns = platform == PlatformType.Admin ? [...adminSearchColumns, ...commonSearchColumns] : [...commonSearchColumns];

    const toolbar = (
        <Space>
            <AddButton type={"primary"} onClick={() => history.push('/rebate/rebate/add/')}>新增</AddButton>
            <ImportButton type={"primary"} onClick={() => setUploadModalVisible(true)}>导入</ImportButton>
        </Space>
    )

    return <PageHeaderLayout>
        <StandardTable {...tableProps} form={form} submit={search.submit} columns={columns} search={search}
                       extSearchColumns={searchColumns} toolbar={toolbar}/>
        <UploadModal onUpload={doImport}
                     open={uploadModalVisible}
                     title={'导入返利单'}
                     template={'/template/返利订单导入模版.xlsx'}
                     confirmLoading={doImportLoading}
                     onCancel={() => setUploadModalVisible(false)}/>
    </PageHeaderLayout>
}

export default Rebate;
